// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"81":"a49150cd","358":"48f0cca4","361":"705388aa","479":"347b0935","645":"841d93e4","770":"3daa23d5","869":"6e95d0e6","900":"6ea77e29","928":"79ddc760","953":"c708bf7a","956":"c98ee7d6"}[chunkId] + ".chunk.js";
};